export default function (val) {
  if (!val) return null
  // remove commas 
  const formatted = val.replace(/\D+/g, '')
  // format to bgp
  const gbp = new Intl.NumberFormat('en-GB').format(formatted)
  // remove commas again after format
  return Number(gbp.replace(/\D+/g, ''))
}
